import { ga } from 'js/analytics/adapters'

export const trackAuthenticationError = ({
  errorType,
  authMethod,
  errorMessage = '',
  couponCode = '',
  entryPoint = '',
  statusCode = null,
  userAgent = '',
}) => {
  ga.track('authentication_error', {
    error_type: errorType,
    auth_method: authMethod,
    error_message: errorMessage,
    coupon_code: couponCode,
    entry_point: entryPoint,
    status_code: statusCode,
    user_agent: userAgent,
  })
}
